import { customFetch } from 'utils/customFetch';
import { getSportingServiceURL } from 'services/sporting/utils/getSportingURL';
import { UnexpectedError } from 'utils/errors';
import { TSportingUserInfo } from 'services/sporting/types';
import { createSportingHeaders } from 'services/sporting/utils/createSportingHeaders';

export const getUserInfo = async (): Promise<TSportingUserInfo> => {
  const endpointURL = getSportingServiceURL('getUserInfo');

  const headers = createSportingHeaders();

  const response = await customFetch(endpointURL, { headers });

  if (!response.ok) {
    throw new UnexpectedError();
  }
  return response.json();
};
